module.exports = __webpack_public_path__ + "img/right3.9f60e79.png";